import { SVGIconProps } from 'fe-design-base/atoms/Icon/Icon';
const SvgChevronLeft = ({
  alt = 'Chevron Left Icon',
  id,
  screenReadable = false,
}: SVGIconProps) => (
  <svg
    {...(screenReadable
      ? { role: 'img', 'aria-labelledby': id }
      : { 'aria-hidden': 'true' })}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    {screenReadable && <title id={id}>{alt}</title>}
    <path
      fill="currentColor"
      d="M6.281 11.27 16.1.36a1.09 1.09 0 1 1 1.621 1.462L8.558 12l9.162 10.18c.401.45.366 1.136-.08 1.54a1.092 1.092 0 0 1-1.541-.08L6.282 12.79c-.376-.478-.376-1.105 0-1.52Z"
    />
  </svg>
);
export default SvgChevronLeft;
